    <div class="col-12 events">
        <h5 class="events__title">Próximos eventos</h5>
        <ngb-carousel
            [showNavigationIndicators]="false"
            [interval]="20000"
            [pauseOnHover]="true"
            [pauseOnFocus]="true">
            <ng-template ngbSlide *ngFor="let event of eventos; index as i">
                <div class="col" style="text-align: center">
                    <p>{{event.PAD35FEC}}</p>
                    <h5 class="events__text">{{event.PAD35NOM}}</h5>
                    <p>{{event.PAD35DES}}</p>
                    <!-- <button class="btn btn-sm btn-info" id="{{event.PAD35NOM}}-{{i}}">Ver evento</button> -->
                </div>
                <div class="col" class="events__text">
                    ......
                </div>
            </ng-template>
        </ngb-carousel>
    </div>